import {
    ILocationKcfInformationResponse,
    LocationKcfInformationResponse,
} from '@kcftech/prometheus-client';
import {
    QueryObserverOptions,
    QueryObserverResult,
    skipToken,
    useQuery,
} from '@tanstack/react-query';
import { dayMs, hourMs } from 'components/date_time/time';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

type QueryData = LocationKcfInformationResponse | undefined;
type QueryError = Partial<Error>;

export const locationKcfInfoQueryKey = 'location-kcf-info';

export function useLocationKcfInfo(
    id: string | undefined,
    options?: QueryObserverOptions<QueryData, QueryError>,
): QueryObserverResult<ILocationKcfInformationResponse | undefined, Partial<Error>> {
    return useQuery<QueryData, QueryError>({
        queryKey: [locationKcfInfoQueryKey, id],

        queryFn: id
            ? () => sdClient.getLocationKcfInformation({ locationId: id })
            : skipToken,

        gcTime: 7 * dayMs,
        staleTime: hourMs,
        ...options,
    });
}

export function invalidateLocationKcfInfo(id: string) {
    queryClient.invalidateQueries({
        queryKey: [locationKcfInfoQueryKey, id],
    });
}
